export default __webpack_public_path__ + "static/media/Smart_plug_Current_v.9b4c71b5.svg";